module.exports = __webpack_public_path__ + "img/background_pattern.2febb8ca.png";